module.exports = __webpack_public_path__ + "img/knus_main2.dbdb4dd1.jpg";